<template>
  <div>
    <div
      style="display: none; font-size: 1px; color: transparent; opacity: 0; line-height: 1px; font-family: 'Lato', sans-serif; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;"
    >
      เริ่มถกและคุยกัน
    </div>
    <!-- TOPER: START -->
    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      bgcolor="#6D27BF"
      style="background-color: #6D27BF1A;"
      class="mainTable mlBodyBackground"
      dir="ltr"
    >
      <tr>
        <td
          height="18"
          class="spacingHeight-18"
          style="line-height: 18px; min-height: 18px;"
        ></td>
      </tr>
    </table>

    <!-- TOPER: END -->
    <table
      border="0"
      cellspacing="0"
      cellpadding="0"
      style="background-color: #fff; width: 100%; border-collapse: collapse;"
    >
      <tbody>
        <tr>
          <!-- BODY CONTENT -->
          <td align="center">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              width="428"
              style="background-color: #fff; width: 100%; border-collapse: collapse; width: 428px;"
            >
              <tr>
                <td
                  height="20"
                  class="spacingHeight-20"
                  style="line-height: 20px; min-height: 20px;"
                ></td>
              </tr>

              <!-- EMAIL HEADER -->
              <tr>
                <td align="center" style="padding:0;">
                  <table
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                    style="width:460px;border-collapse:collapse;"
                  >
                    <tbody>
                      <tr>
                        <td>
                          <table cellspacing="0" cellpadding="0" border="0">
                            <tbody>
                              <tr>
                                <td align="center">
                                  <img
                                    src="@/assets/images/dimension/Recognition@2x.png"
                                    width="52"
                                    height="52"
                                    style="border-radius:52px;object-fit:cover;padding-right: 12px;"
                                    data-bit="iit"
                                  />
                                </td>
                                <td
                                  align="left"
                                  bgcolor="#FFFFFF"
                                  style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                                >
                                  <p
                                    style="font-size:19px;color:#000;font-weight:900;margin:0"
                                  >
                                    Happily Leadership
                                  </p>
                                  <p
                                    style="font-size:15px;color:#000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;font-weight:400;margin:0"
                                  >
                                    Recognition Nudge
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  height="18"
                  class="spacingHeight-18"
                  style="line-height: 18px; min-height: 18px; border-bottom: 1px solid #0000001a;"
                ></td>
              </tr>

              <tr>
                <!-- TITLE -->
                <td style="padding: 0 36px;">
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    style="background-color: #fff; width: 100%; border-collapse: collapse;"
                  >
                    <tr>
                      <td
                        height="32"
                        class="spacingHeight-32"
                        style="line-height: 32px; min-height: 32px;"
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                      >
                        <span
                          style="font-size: 16px; color: #6D27BF; font-weight: 700;"
                        >
                          Leadership Tip
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        height="6"
                        class="spacingHeight-6"
                        style="line-height: 6px; min-height: 6px;"
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                      >
                        <span
                          style="font-size: 30px; line-height: 30px; color: #000; font-weight: 900;"
                        >
                          Reinforcing our values
                        </span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  height="16"
                  class="spacingHeight-16"
                  style="line-height: 16px; min-height: 16px;"
                ></td>
              </tr>

              <tr>
                <!-- Recognition -->
                <td style="padding: 0 24px;">
                  <table cellspacing="0" cellpadding="0" border="0">
                    <tr>
                      <td>
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="424"
                          style="font-family: 'Lato', sans-serif; border-radius: 6px; overflow: hidden; border: 1px solid #ddd;"
                        >
                          <tr>
                            <td align="left" bgcolor="#FFFFFF">
                              <table cellspacing="0" cellpadding="0" border="0">
                                <tr>
                                  <td
                                    align="left"
                                    style="padding: 6px; font-size: 10px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    align="center"
                                    style="vertical-align: top; padding-top: 12px; padding-bottom: 12px;"
                                  >
                                    <img
                                      src="https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fprofiles2%2F-Kv0X8SSurYL3y1MZAWL%2Fsmall%2Fpawadee_p@dhas.com_20220302073921.jpg?alt=media&rand=627"
                                      width="40"
                                      height="40"
                                      style="border-radius: 50%; padding: 0px 0; object-fit: cover;"
                                    />
                                  </td>
                                  <td
                                    align="left"
                                    style="font-family: 'Lato', sans-serif; padding: 12px 16px 12px 12px;"
                                  >
                                    <div
                                      style="font-size: 16px; color: #050505; font-weight: 400; margin:0;"
                                    >
                                      <span style="font-weight: 700;"
                                        >Pawadee P</span
                                      >
                                      got
                                      <span style="font-weight: 700;"
                                        >+3 coins</span
                                      >
                                      from
                                      <span style="font-weight: 700;"
                                        >Danupol S</span
                                      >
                                      for patiently and diligently updating
                                      micro-elements of our user experience
                                      while we learn how to get the best out of
                                      the AI interface for the power skill
                                      analytics. Thank you always being
                                      #responsive to continuously improve our
                                      product
                                      <span
                                        style="font-size: 16px; color: #0CACA5; font-weight:400; margin:0;"
                                      >
                                        #operationalexcellence #openness</span
                                      >
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td
                        height="12"
                        class="spacingHeight-12"
                        style="line-height: 12px; min-height: 12px;"
                      ></td>
                    </tr>
                    <tr>
                      <td>
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="424"
                          style="font-family: 'Lato', sans-serif; border-radius: 6px; overflow: hidden; border: 1px solid #ddd;"
                        >
                          <tr>
                            <td align="left" bgcolor="#FFFFFF">
                              <table cellspacing="0" cellpadding="0" border="0">
                                <tr>
                                  <td
                                    align="left"
                                    style="padding: 6px; font-size: 10px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    align="center"
                                    style="vertical-align: top; padding-top: 12px; padding-bottom: 12px;"
                                  >
                                    <img
                                      src="https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fprofiles2%2F-Kv0X8SSurYL3y1MZAWL%2Fsmall%2Fpawadee_p@dhas.com_20220302073921.jpg?alt=media&rand=627"
                                      width="40"
                                      height="40"
                                      style="border-radius: 50%; padding: 0px 0; object-fit: cover;"
                                    />
                                  </td>
                                  <td
                                    align="left"
                                    style="font-family: 'Lato', sans-serif; padding: 12px 16px 12px 12px;"
                                  >
                                    <div
                                      style="font-size: 16px; color: #050505; font-weight: 400; margin:0;"
                                    >
                                      <span style="font-weight: 700;"
                                        >Pawadee P</span
                                      >
                                      got
                                      <span style="font-weight: 700;"
                                        >+3 coins</span
                                      >
                                      from
                                      <span style="font-weight: 700;"
                                        >Danupol S</span
                                      >
                                      for delivering the Email Report on-time
                                      <sapn
                                        style="font-size: 16px; color: #0CACA5; font-weight:400; margin:0;"
                                      >
                                        #excellence #openness</sapn
                                      >
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td
                        height="12"
                        class="spacingHeight-12"
                        style="line-height: 12px; min-height: 12px;"
                      ></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  height="12"
                  class="spacingHeight-12"
                  style="line-height: 12px; min-height: 12px;"
                ></td>
              </tr>

              <tr>
                <!-- ALIGNMENT CHECK -->
                <td style="padding: 0 36px;">
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    style="background-color: #fff; width: 100%; border-collapse: collapse;"
                  >
                    <tr>
                      <td
                        style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                      >
                        <span
                          style="font-size: 14px; color: #6D27BF; font-weight: 700;"
                        >
                          ALIGNMENT CHECK
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td
                        height="12"
                        class="spacingHeight-12"
                        style="line-height: 12px; min-height: 12px;"
                      ></td>
                    </tr>
                    <tr>
                      <td>
                        <!-- GREEN -->
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="400"
                          style="background-color: #EFFDEF"
                        >
                          <tr>
                            <td
                              height="16"
                              class="spacingHeight-16"
                              style="line-height: 16px; min-height: 16px;"
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <span
                                style="font-size: 18px; line-height: 18px; font-weight: 900"
                              >
                                #operationalexcellence
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 14px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <table
                                cellspacing="3"
                                cellpadding="0"
                                style="padding-top: 6px; width: 100%;"
                              >
                                <tr>
                                  <!-- TODO: Loop td tag -->
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #66BB6A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; color: #1C9F23; font-size: 14px; font-weight: 700;"
                            >
                              Strong alignment
                            </td>
                          </tr>
                          <tr>
                            <td
                              height="8"
                              class="spacingHeight-8"
                              style="line-height: 8px; min-height: 8px;"
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; font-size: 16px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <div>
                                Diligently updating micro-elements, improving AI
                                interface, power skill analytics.
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              height="16"
                              class="spacingHeight-16"
                              style="line-height: 16px; min-height: 16px;"
                            ></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td
                        height="12"
                        class="spacingHeight-12"
                        style="line-height: 12px; min-height: 12px;"
                      ></td>
                    </tr>
                    <tr>
                      <td>
                        <!-- YELLOW -->
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="400"
                          style="background-color: #FFFCEF"
                        >
                          <tr>
                            <td
                              height="16"
                              class="spacingHeight-16"
                              style="line-height: 16px; min-height: 16px;"
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <span
                                style="font-size: 18px; line-height: 18px; font-weight: 900"
                              >
                                #openness
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 14px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <table
                                cellspacing="3"
                                cellpadding="0"
                                style="padding-top: 6px; width: 100%;"
                              >
                                <tr>
                                  <!-- TODO: Loop td tag -->
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #FAD71A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #FAD71A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #FAD71A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #FAD71A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #FAD71A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; color: #D6A11E; font-size: 14px; font-weight: 700; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              Strong alignment
                            </td>
                          </tr>
                          <tr>
                            <td
                              height="8"
                              class="spacingHeight-8"
                              style="line-height: 8px; min-height: 8px;"
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; font-size: 16px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <div>
                                Appreciation for time, support, and
                                collaboration to solve issues.
                              </div>
                              <div style="padding-top: 8px;">
                                <span style="font-weight: 700;"
                                  >Recommendation</span
                                >
                                <span
                                  >: Highlight openness in sharing insights,
                                  addressing feedback, teamwork.</span
                                >
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              height="16"
                              class="spacingHeight-16"
                              style="line-height: 16px; min-height: 16px;"
                            ></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td
                        height="12"
                        class="spacingHeight-12"
                        style="line-height: 12px; min-height: 12px;"
                      ></td>
                    </tr>
                    <tr>
                      <td>
                        <!-- RED -->
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="400"
                          style="background-color: #FFF4F4"
                        >
                          <tr>
                            <td
                              height="16"
                              class="spacingHeight-16"
                              style="line-height: 16px; min-height: 16px;"
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <span
                                style="font-size: 18px; line-height: 18px; font-weight: 900"
                              >
                                #operationalexcellence
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 14px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <table
                                cellspacing="3"
                                cellpadding="0"
                                style="padding-top: 6px; width: 100%;"
                              >
                                <tr>
                                  <!-- TODO: Loop td tag -->
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #F44336; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #F44336; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #F44336; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                  <td
                                    height="6"
                                    class="spacingHeight-6"
                                    style="line-height: 6px; min-height: 6px; width: 10%; background-color: #0000001A; font-size: 6px;"
                                  >
                                    &nbsp;
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; color: #F44336; font-size: 14px; font-weight: 700; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              Weak alignment
                            </td>
                          </tr>
                          <tr>
                            <td
                              height="8"
                              class="spacingHeight-8"
                              style="line-height: 8px; min-height: 8px;"
                            ></td>
                          </tr>
                          <tr>
                            <td
                              style="padding: 0 18px; font-size: 16px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                            >
                              <div>
                                Appreciation for time, support, and
                                collaboration to solve issues.
                              </div>
                              <div style="padding-top: 8px;">
                                <span style="font-weight: 700;"
                                  >Recommendation</span
                                >
                                <span
                                  >: Highlight openness in sharing insights,
                                  addressing feedback, teamwork.</span
                                >
                              </div>
                              <div
                                style="font-style: italic; padding-top: 12px;"
                              >
                                This #value tag has been removed from your peer
                                recognition due to weak alignment.
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              height="16"
                              class="spacingHeight-16"
                              style="line-height: 16px; min-height: 16px;"
                            ></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td
                        height="16"
                        class="spacingHeight-16"
                        style="line-height: 16px; min-height: 16px; "
                      ></td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif; padding: 0 36px;"
                >
                  <span style="font-size: 18px">
                    Our core values guide our decision-making and behaviors at
                    work. You’re an essential part of reinforcing and upholding
                    our values.
                  </span>
                </td>
              </tr>

              <tr>
                <td
                  height="32"
                  class="spacingHeight-32"
                  style="line-height: 32px; min-height: 32px"
                ></td>
              </tr>

              <tr>
                <td style="padding: 0 36px">
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    style="background-color: #fff; width: 100%; border-collapse: collapse;"
                  >
                    <tr>
                      <td
                        align="center"
                        class=""
                        style="font-family:'Source Sans Pro',Arial,Helvetica,sans-serif"
                      >
                        <a
                          href="https://happily.ai"
                          data-saferedirecturl="https://happily.ai"
                          style="font-family: 'Lato', Arial, Helvetica, sans-serif;
                          background-color:#fff;
                          border-radius:6px;
                          border: 1px solid #6D27BF;
                          color:#6D27BF;
                          font-weight:700;
                          padding: 15px 0 15px 0;
                          text-align: center;
                          text-decoration:none;
                          width:100%;font-size: 16px;
                          display: flex;
                          align-content: center;
                          justify-content: center;
                          align-items: center;"
                          target="_blank"
                        >
                          <div style="text-align: center; margin: auto;">
                            REPORT AN ISSUE
                          </div>
                        </a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  height="12"
                  class="spacingHeight-12"
                  style="line-height: 12px; min-height: 12px"
                ></td>
              </tr>

              <tr>
                <!-- LINE -->
                <td
                  height="24"
                  class="spacingHeight-24"
                  style="line-height: 24px; min-height: 24px; border-bottom: 1px solid #0000001a;"
                ></td>
              </tr>
              <tr>
                <td
                  height="24"
                  class="spacingHeight-24"
                  style="line-height: 24px; min-height: 24px;"
                ></td>
              </tr>
              <tr>
                <!-- FOOTER -->
                <td
                  style="padding: 0 36px; font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                >
                  <div style="font-size: 16px;">
                    <span style="font-weight: 700;"
                      >This tip is related to </span
                    >improving
                    <span style="font-weight: 700;">Happiness</span>
                    getting a micro-level understanding of people to provide
                    timely support and interventions
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  height="56"
                  class="spacingHeight-56"
                  style="line-height: 56px; min-height: 56px;"
                ></td>
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- FOOTER: START -->
    <table
      width="100%"
      border="0"
      cellspacing="0"
      cellpadding="0"
      bgcolor="#6D27BF"
      class="mainTable mlBodyBackground"
      dir="ltr"
      style="background-color: #6D27BF0A;"
    >
      <tr>
        <td class="mlTemplateContainer" align="center">
          <table
            align="center"
            border="0"
            class="mlContentTable mlContentTableDefault"
            cellpadding="0"
            cellspacing="0"
            width="500"
          >
            <tr>
              <td class="mlContentTableCardTd">
                <table
                  align="center"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  class="mlContentTable ml-default"
                  style="width: 500px; min-width: 500px;"
                  width="400"
                >
                  <tr>
                    <td>
                      <table
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                        align="center"
                        width="400"
                        style="width: 500px; min-width: 500px;"
                        class="mlContentTable"
                      >
                        <tr>
                          <td
                            height="44"
                            class="spacingHeight-44"
                            style="line-height: 44px; min-height: 44px;"
                          ></td>
                        </tr>
                      </table>

                      <table
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                        align="center"
                        width="400"
                        style="width: 500px; min-width: 500px;"
                        class="mlContentTable"
                      >
                        <tr>
                          <td
                            align="center"
                            style="font-family:'Lato', 'Source Sans Pro', Arial, Helvetica, sans-serif;"
                          >
                            <p
                              style="margin-top: 0px; margin-bottom: 0px; line-height: 16px;"
                            >
                              <span style="color: #000; opacity: 0.6;"
                                >Happily
                              </span>
                              <span style="color: #F22F3C; font-weight: 700;"
                                >♥</span
                              >
                              <span style="color: #000; opacity: 0.6;">
                                ${company.name}</span
                              >
                            </p>
                          </td>
                        </tr>
                      </table>

                      <table
                        role="presentation"
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                        align="center"
                        width="400"
                        style="width: 500px; min-width: 500px;"
                        class="mlContentTable"
                      >
                        <tr>
                          <td
                            height="44"
                            class="spacingHeight-44"
                            style="line-height: 44px; min-height: 44px;"
                          ></td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <!-- FOOTER: END -->
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import format from "date-fns/format";
import addDays from "date-fns/add_days";
export default {
  name: "weekly-insights",
  data() {
    return {
      id: "",
    };
  },
  mounted() {
    if (this.$route.params.id) {
      console.log(this.$route.params.id);
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
body,
html {
  padding: 0;
  margin: 0;
  font-family: "Lato", Arial, Helvetica, sans-serif;
}
</style>
